import { PremiumPurchasePremiumBadge } from '../common/premium-purchase-premium-badge'
import { PremiumPurchaseBoostersBadge } from '../common/purchase-boosters-badge'

import type { PairActivity } from '../../model'
import type { ClassNameProps } from '@root/shared/react'

type Props = {
  activity: PairActivity.PremiumActivity
} & ClassNameProps

export const PremiumFeedTablePurchaseColumn: React.FC<Props> = ({
  activity,
}) => {
  if (activity.type === 'boost-purchased') {
    return <PremiumPurchaseBoostersBadge boosters={activity.boostersAmount} />
  }
  return <PremiumPurchasePremiumBadge activity={activity} />
}
